module.exports = __webpack_public_path__ + "img/gradient.a872a277.png";